import { render, staticRenderFns } from "./AdminMeldungen.vue?vue&type=template&id=0d0757d3&"
import script from "./AdminMeldungen.vue?vue&type=script&lang=js&"
export * from "./AdminMeldungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports